import React, { useCallback, useEffect, useState } from "react"
import {
    AlertType, FormaPagamento, FormaPagamentoSearchBox, LanctoFormaPag, RetAPI, classBorderLabelDark, classBt, classInput, classInputDark, classLabel, classLabelDark, classbtAzul,
    classbtColunasVermelho, classbtVerde, classbtVermelho, contaAReceberLiquidar
} from "../../Utils/Types"
import { Funcoes } from "../../Utils/Funcoes"
import { SearchBox } from "../SearchBox/SearchBox"
import { FeedbackMessage } from "../FeedbackMessage/feedback-message"
import { FaPlus, FaTrashAlt } from "react-icons/fa"
import { ContaAReceberService } from "../../Pages/ContasAReceber/ContaAReceberService"
import { FormaPagamentoService } from "../../Pages/FormaPagamento/FormaPagamentoService"
import moment from "moment"
import { ModalImpress } from "./modal-impress"
import { ReportReciboContaReceberBobina } from "../../Pages/ContasAReceber/pdf/report-reciboDupReceberBobina"
import { ReportReciboContaReceberA4 } from "../../Pages/ContasAReceber/pdf/report-reciboDupReceberA4"
import { HiDocumentCheck } from "react-icons/hi2"

export type Props = {
    visible: boolean,
    totSelecionado: number,
    totJuros: number,
    handleModalClose: () => void,
    handleConfirm: () => Promise<boolean>,
    dupSelectedList: number[],
    tipo_baixa: string
    idCliente?: number
}

export const ModalLiqDupReceber = React.memo(({ visible, handleModalClose, handleConfirm, dupSelectedList, totSelecionado, totJuros, tipo_baixa, idCliente }: Props) => {

    let attr: contaAReceberLiquidar = {
        tipo_baixa: '',
        id_cliente: 0,
        valor_baixa: 0,
        valor_juros: 0,
        taxa_juros: 0,
        diasJuros: 0,
        valor_desconto: 0,
        dtpagto: '',
        senha_usuario: '',
        observacao: '',
        duplicatas: [],
        pagamentos: []
    }

    // ---------- ATRIBUTOS FEEDBACK ---------------------------------------------
    const [loading, setLoading] = useState<boolean>(false)
    const [visibleMsg, setVisibleMsg] = useState<boolean>(false)
    const [message, setMessage] = useState("")
    const [messageType, setMessageType] = useState<AlertType>("DANGER")

    // ---------- ATRIBUTOS  -----------------------------------------------------
    const [valor_baixa, setValor_Baixa] = useState("0,00")
    const [valor_baixaCopy, setValor_BaixaCopy] = useState("0,00")
    const [valor_baixa_juros, setValor_Baixa_Juros] = useState("0,00")
    const [valor_baixa_jurosCopy, setValor_Baixa_JurosCopy] = useState("0,00")
    const [valor_baixa_total, setValor_Baixa_Total] = useState("0,00")
    const [valor_desconto, setValor_Desconto] = useState("0,00")
    const [valor_juros, setValor_Juros] = useState("0,00")
    const [valor_restante_original, setValor_Restante_Origianl] = useState("0,00")
    const [valor_restante, setValor_Restante] = useState("0,00")
    const [dataPagto, setDataPagto] = useState(moment().format("YYYY-MM-DD"))
    const [senha_usuario_dup_receber, setSenhaUsuario] = useState("")
    const [observacao_dup_receber, setObservacao] = useState("")

    // --------------- ATRIBUTOS LANCAMENTO FORMA DE PAGAMENTO ----------------------------
    const [lanctoFormaPagList, setLanctoFormaPagList] = useState<LanctoFormaPag[]>([])
    const [formaPag, setFormaPag] = useState<FormaPagamentoSearchBox[]>([])
    const [formaPagList, setFormaPagList] = useState<FormaPagamentoSearchBox[]>([])
    const [idFormaPag, setIdFormaPag] = useState<number>(0)
    const [valorFormaPag, setValorFormaPag] = useState("0,00")
    const [descFormaPag, setDescFormaPag] = useState("")

    // --------------- ATRIBUTOS IMPRESSÃO ---------------------------- ---------------------
    const [visibleImpressDupReceber, setVisibleImpressDupReceber] = useState(false)
    const [dadosParaImpressao, setDadosParaImpressao] = useState<RetAPI>()
    const [visibleImpressDupReceberBobina, setVisibleImpressDupReceberBobina] = useState(false)
    const [visibleImpressDupReceberA4, setVisibleImpressDupReceberA4] = useState(false)

    // ------------------- SEARCH BOX ---------------------------------------------------------
    const [visibleSearchBoxFormPag, setVisibleSearchBoxFormPag] = useState<boolean>(false)

    //------------------------------------------------------------------- ATRIBUTOS E EFFECT ------------------------------------------------------------------------||
    const getAttributes = async () => {

        setLoading(true)
        try {

            const resp = await FormaPagamentoService.GetListFormaPagto()
            setFormaPagList(resp.data)

        } catch {
            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Não foi possivel buscar as formas de pagamento`)

        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {

        if (visible) {

            let valorTotal = (totSelecionado || 0) + (totJuros || 0)

            setLanctoFormaPagList([])
            setValor_Baixa(Funcoes.numberFormat((totSelecionado?.toString() || '0'), 'decimal', 2, 2))
            setValor_BaixaCopy(Funcoes.numberFormat((totSelecionado?.toString() || '0'), 'decimal', 2, 2))
            setValor_Baixa_Juros(Funcoes.numberFormat((totJuros?.toString() || '0'), 'decimal', 2, 2))
            setValor_Baixa_JurosCopy(Funcoes.numberFormat((totJuros?.toString() || '0'), 'decimal', 2, 2))
            setValor_Baixa_Total(Funcoes.numberFormat((valorTotal?.toString() || '0'), 'decimal', 2, 2))
            setValor_Restante_Origianl(Funcoes.numberFormat(valorTotal || '0', 'decimal', 2, 2))

            getAttributes()

            let modal = document.getElementById('modal_duplicata_receber')
            let modalContent = document.getElementById('modal_content_duplicata_receber')

            if (modal) {
                modal.style.visibility = 'visible'

                if (modalContent) {
                    modalContent.classList.remove('mt-[-1000px]')
                    modalContent.classList.add('mt-24')
                }
            }

        } else {

            let modal = document.getElementById('modal_duplicata_receber');
            let modalContent = document.getElementById('modal_content_duplicata_receber');

            if (modal) {
                modal.style.visibility = 'hidden';

                if (modalContent) {
                    modalContent.classList.add('mt-[-1000px]');
                    modalContent.classList.remove('mt-24');
                }
            }

            setVisibleSearchBoxFormPag(false)
        }

    }, [visible])

    useEffect(() => {
        calcularVlBaixa()
    }, [valor_juros, valor_desconto])

    useEffect(() => {

        // soma total da lista
        const valorLista = lanctoFormaPagList.reduce((acc, item) => acc + Number(item.valor || 0), 0);

        // valor restante original (convertido corretamente para número)
        const valorOriginal = parseFloat(valor_restante_original.replaceAll(".", "").replace(",", ".")) || 0;

        // valor restante atualizado
        const valorRestante = valorOriginal - valorLista - parseFloat(valor_desconto) + parseFloat(valor_juros);

        // seta no state já formatado
        setValor_Restante(Funcoes.numberFormat(valorRestante, 'decimal', 2, 2));

    }, [lanctoFormaPagList, valor_juros, valor_desconto]);

    const searchBoxFocus = () => {
        setVisibleSearchBoxFormPag(false)

    }

    const calcularVlBaixa = () => {
        let vlJuros = valor_juros
        let vlDesconto = valor_desconto

        let vlBaixaJurosCopy = valor_baixa_jurosCopy.replaceAll(".", "").replace(",", ".")
        let vlBaixaCopy = valor_baixaCopy.replaceAll(".", "").replace(",", ".")

        let totalJuros = parseFloat(vlBaixaJurosCopy) + parseFloat(vlJuros)
        setValor_Baixa_Juros(Funcoes.numberFormat(totalJuros, 'decimal', 2, 2))

        let total = parseFloat(vlBaixaCopy) + totalJuros - parseFloat(vlDesconto)
        setValor_Baixa_Total(Funcoes.numberFormat(total, 'decimal', 2, 2))
    }


    //--------------------------------------------------------------------------------------------- INPUTS ------------------------------------------------------------------------------------------//
    const handleChangeValorJuros = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValor_Juros(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeValorDesconto = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValor_Desconto(Funcoes.MaskMoney(e.target.value))
    }

    const handleChangeDataPagto = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataPagto(e.target.value)
    }

    const handleChangeSenhaUsuario = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSenhaUsuario(e.target.value)
    }

    const handleChangeObservacao = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setObservacao(e.target.value)
    }


    //--------------------------------------------------------------------------------------------- FORMA DE PAGAMENTO ------------------------------------------------------------------------------------------//
    const handleClearFormaPagSelecionado = useCallback(() => {

        setIdFormaPag(0)
        setVisibleSearchBoxFormPag(false)

    }, [formaPagList])

    const handleFilterFormaPagClick = useCallback((description: string) => {

        if (description === "") {

            const newFormaPagList = [...formaPagList || []]
            setFormaPag(newFormaPagList || [])

        } else {

            const newFormaPagList = [...formaPagList || []].filter((item) => {
                return item.description.toLocaleLowerCase().startsWith(description.toLocaleLowerCase())
            })
            setFormaPag(newFormaPagList || [])
        }

    }, [formaPagList])

    const handleFormaPagSelectClick = useCallback((v: FormaPagamentoSearchBox) => {

        if (v) {
            setIdFormaPag(v.id)
            setDescFormaPag(v.description)
        }

        setVisibleSearchBoxFormPag(false)

    }, [formaPagList])

    const handleChangeFormaPag = (e: React.ChangeEvent<HTMLInputElement>) => {
        setValorFormaPag(Funcoes.MaskMoney(e.target.value))
    }

    const handleAddFormaPagListClick = () => {

        setVisibleMsg(false)

        let newLanctoFormaPagList = lanctoFormaPagList.filter(it => it.id_fpagto === idFormaPag)

        if (parseFloat(valorFormaPag) <= 0 || isNaN(parseFloat(valorFormaPag))) {

            const aguarde = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(`Valor da conta inválido`)

                clearTimeout(aguarde)
            }, 250)
            return
        }

        if (idFormaPag === 0) {
            const aguarde = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(`Forma de Pagamento não informada`)
                clearTimeout(aguarde)
            }, 250)

            return
        }

        if (newLanctoFormaPagList.length > 0) {
            const aguarde = setTimeout(() => {
                setVisibleMsg(true)
                setMessageType("DANGER")
                setMessage(`Forma de Pagamento já lançada`)
                clearTimeout(aguarde)
            }, 250)

            return
        }

        const lanctoConta: LanctoFormaPag = {
            id_fpagto: idFormaPag,
            description: descFormaPag,
            valor: parseFloat(valorFormaPag)
        }

        setLanctoFormaPagList(prev => [...prev, lanctoConta]);

        setIdFormaPag(0)
        setDescFormaPag("")
        setValorFormaPag("0.00")

    }

    const handleRemoveFormaPagListClick = (item: LanctoFormaPag) => {
        setLanctoFormaPagList(prev => prev.filter(it => it.id_fpagto !== item.id_fpagto));
    }

    const clickSearchBoxFormPag = useCallback(() => {
        setVisibleSearchBoxFormPag((prevState) => {
            const newState = !prevState; // Alterna o estado atual
            if (newState) {
                inputFocusFormPag();
            }
            return newState;
        });

    }, [])

    const inputFocusFormPag = () => {
        let inputSearch = document.getElementById(`inputSearchBox-formaPagLiquidado`) as HTMLInputElement

        const timer = setTimeout(() => {
            inputSearch?.focus()
            clearTimeout(timer)
        }, 10)
    }


    //---------------------------------------------------------------------------------------------  LIQUIDAR DUPLICATAS RECEBER ------------------------------------------------------------------------------------------//
    const handleLiquidarDuplicata = async () => {

        setLoading(true)
        setVisibleMsg(false)

        try {

            const taxaPadrao = parseFloat(localStorage.getItem("@ecommerce/taxa_juros") || '0')
            const diasJuros = parseFloat(localStorage.getItem("@ecommerce/diasJuros") || '0')

            let totFormaPag = 0
            lanctoFormaPagList.map(item => totFormaPag += item.valor)

            const parametros: contaAReceberLiquidar = {
                tipo_baixa: '',
                id_cliente: 0,
                valor_baixa: 0,
                valor_juros: 0,
                taxa_juros: 0,
                diasJuros: 0,
                valor_desconto: 0,
                dtpagto: '',
                senha_usuario: '',
                observacao: '',
                duplicatas: [],
                pagamentos: []
            }

            let valorPagamento = lanctoFormaPagList.reduce((acc, item) => acc + item.valor, 0);

            parametros.tipo_baixa = valorPagamento < parseFloat(valor_baixa_total.replaceAll(".", "").replace(",", '.')) ? 'V' : 'D'
            parametros.id_cliente = idCliente || 0
            parametros.valor_baixa = parseFloat(valor_baixa_total.replaceAll(".", "").replace(",", '.'))
            parametros.valor_juros = dupSelectedList.length > 1 ? 0 : parseFloat(valor_baixa_juros.replaceAll(".", "").replace(",", '.'))
            parametros.taxa_juros = taxaPadrao
            parametros.diasJuros = diasJuros
            parametros.valor_desconto = parseFloat(valor_desconto)
            parametros.dtpagto = dataPagto
            parametros.senha_usuario = senha_usuario_dup_receber
            parametros.observacao = observacao_dup_receber
            parametros.duplicatas = dupSelectedList
            parametros.pagamentos = lanctoFormaPagList

            //console.log("parametros: ", parametros)

            const retAPI = await ContaAReceberService.Liquidar(parametros)

            if (retAPI.error) {

                const aguarde = setTimeout(() => {
                    setVisibleMsg(true)
                    setMessageType("DANGER")
                    setMessage(retAPI.msg || '')

                    clearTimeout(aguarde)
                }, 250)

            } else {

                setVisibleMsg(true)
                setMessageType("SUCCESS")
                setMessage(`Duplicata(s) liquidada com sucesso`)

                //console.log("retAPI: ", retAPI)
                setDadosParaImpressao(retAPI)
                setVisibleImpressDupReceber(true)

                handleConfirm()
            }

        } catch (error) {

            setVisibleMsg(true)
            setMessageType("DANGER")
            setMessage(`Não foi possível liquidar a(s) duplicata(s). Por favor, tente novamente`)

        } finally {
            setLoading(false)
        }
    }

    const fecharModalImpressDupReceber = useCallback(() => {
        setVisibleImpressDupReceber(false)
        fecharModal()
    }, [messageType])

    const imprimirDupReceberA4 = useCallback(() => {
        setVisibleImpressDupReceber(false)
        setVisibleImpressDupReceberA4(true)
        fecharModal()

        //const pdf = new ReportReciboContaReceberPDF()
        //pdf.GerarPDF(lanctoFormaPagList, dadosParaImpressao?.data.cliente, dadosParaImpressao?.data.duplicatas)
    }, [messageType])

    const imprimirDupReceberBobina = useCallback(() => {
        setVisibleImpressDupReceber(false)
        setVisibleImpressDupReceberBobina(true)
        fecharModal()
    }, [messageType])

    const fecharModalBobina = useCallback(() => {
        setVisibleImpressDupReceberBobina(false)
    }, [])

    const fecharModalA4 = useCallback(() => {
        setVisibleImpressDupReceberA4(false)
    }, [])

    const clearFields = () => {
        setValor_Baixa('')
        setValor_Baixa_Juros('')
        setValor_Baixa_Total('')
        setSenhaUsuario('')
        setObservacao('')
        setLanctoFormaPagList([])
    }

    const fecharModal = () => {

        if (messageType === 'DANGER') {
            setVisibleMsg(false)
        }

        setValor_Baixa("0.00")
        setValor_BaixaCopy("0.00")
        setValor_Baixa_Juros("0.00")
        setValor_Baixa_JurosCopy("0.00")
        setValor_Baixa_Total("0.00")
        setValor_Desconto("0.00")
        setValor_Juros("0.00")
        setDataPagto(moment().format("YYYY-MM-DD"))
        setSenhaUsuario("")
        setObservacao("")
        setIdFormaPag(0)
        setValorFormaPag('')
        setDescFormaPag('')
        setFormaPagList([])
        //setFormaPag([])

        handleModalClose()
    }

    const handleCloseMessage = () => {
        setVisibleMsg(false)
    }

    return (

        <div id="modal_duplicata_receber" style={{ visibility: "hidden", backgroundColor: 'rgba(0,0,0, 0.6)' }} className={`flex justify-center fixed left-0 right-0 top-0 bottom-0 transition-all duration-300 z-40 bg-white`}>

            <div id="modal_content_duplicata_receber" className={`relative flex flex-col w-[95%] md:w-[90%] xl:w-[80%] h-[510px] bg-white dark:bg-slate-600 rounded-lg mt-[-1000px] transition-all duration-300 justify-center items-center`}>

                <FeedbackMessage visible={visibleMsg} message={message} type={messageType} onCloseMessage={handleCloseMessage} />

                <div className={`absolute top-0 w-full h-[70px] flex items-center`}>

                    <div className={`ml-4 flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 dark:bg-slate-500 border border-slate-300 dark:border-slate-700 shadow-sm shadow-slate-500 dark:shadow-slate-800`}>
                        <HiDocumentCheck size={20} className={`w-5 h-5 text-slate-700 dark:text-slate-200`} />
                    </div>

                    <span className={`ml-4 text-lg text-slate-700 dark:text-slate-200 flex items-center font-semibold`}>Liquidar Duplicatas a Receber</span>
                </div>

                <div className={`absolute top-[70px] bottom-[60px] w-full`}>

                    <div className={`grid grid-cols-12 gap-3 bg-white dark:bg-slate-600 py-3 h-full overflow-y-auto px-2`}>

                        <div className={`col-span-12 lg:col-span-6`}>

                            <div className={`grid grid-cols-12 gap-5`}>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 2xl:col-span-4 ${dupSelectedList.length > 1 ? 'hidden' : 'block'}`}>
                                    <input id="valor_bruto_dup_receber" type='text' disabled={true} className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} placeholder=' ' value={valor_baixa} readOnly />
                                    <label htmlFor="valor_bruto_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor Bruto (R$)</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 2xl:col-span-4 ${dupSelectedList.length > 1 ? 'hidden' : 'block'}`}>
                                    <input id="valor_juros_dup_receber" type='text' disabled={true} className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} placeholder=' ' value={valor_baixa_juros} readOnly />
                                    <label htmlFor="valor_juros_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor dos Juros (R$)</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 2xl:col-span-4`}>
                                    <input id="total_liquidar_dup_receber" type='text' disabled={true} className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} placeholder=' ' value={valor_baixa_total} readOnly />
                                    <label htmlFor="total_liquidar_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Total a Liquidar (R$)</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 2xl:col-span-4`}>
                                    <input id="total_restante_dup_receber" type='text' disabled={true} className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} placeholder=' ' value={valor_restante} readOnly />
                                    <label htmlFor="total_restante_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor Restante (R$)</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 2xl:col-span-4 ${dupSelectedList.length > 1 ? 'hidden' : 'block'}`}>
                                    <input id="juros_dup_receber" type='text' className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} placeholder=' ' value={valor_juros} onFocus={searchBoxFocus} onChange={handleChangeValorJuros} />
                                    <label htmlFor="juros_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Juros (R$)</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 2xl:col-span-4`}>
                                    <input id="desconto_dup_receber" type='text' className={`${classInput} ${classInputDark} disabled:bg-slate-200 dark:disabled:bg-slate-700 disabled:cursor-not-allowed`} placeholder=' ' value={valor_desconto} onFocus={searchBoxFocus} onChange={handleChangeValorDesconto} />
                                    <label htmlFor="desconto_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Desconto (R$)</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4 lg:col-span-6 2xl:col-span-4`}>
                                    <input id="data_pagto_dup_receber" className={`${classInput} ${classInputDark} ${dataPagto === "" ? `text-blue-500 dark:text-cyan-300` : ``} dark:[color-scheme:dark]`} type='date' min="1900-01-01" max="9999-12-31" disabled={true} value={dataPagto} onFocus={searchBoxFocus} onChange={handleChangeDataPagto} />
                                    <label htmlFor="data_pagto_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>* Data do Recebimento</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-8 ${dupSelectedList.length > 1 ? 'lg:col-span-12' : 'lg:col-span-6'} 2xl:col-span-8`}>
                                    <input id="senha_usuario_dup_receber" className={`${classInput} ${classInputDark}`} type='password' inputMode="text" placeholder=' ' autoComplete="off" value={senha_usuario_dup_receber} onFocus={searchBoxFocus} onChange={handleChangeSenhaUsuario} />
                                    <label htmlFor="senha_usuario_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>* Senha do Usuário</label>
                                </div>

                                <div className={`relative col-span-12`}>
                                    <textarea id="observacao_dup_receber" className={`${classInput} ${classInputDark} h-[150px] resize-none`} placeholder=' ' autoComplete="off" value={observacao_dup_receber} onFocus={searchBoxFocus} onChange={handleChangeObservacao} />
                                    <label htmlFor="observacao_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Observação</label>
                                </div>

                            </div>

                        </div>

                        <div className={`col-span-12 lg:col-span-6 border border-slate-400 dark:border-slate-700 rounded-sm px-2 h-[500px] sm:h-[350px]`}>

                            <div className={`grid grid-cols-12 gap-5 mt-3`}>

                                <div className={`relative col-span-12 sm:col-span-6`}>
                                    <SearchBox
                                        dataList={formaPag}
                                        idRegistro={idFormaPag || undefined}
                                        label='Forma Pagamento'
                                        componentId="formaPagLiquidado"
                                        visibleTAB={visibleSearchBoxFormPag}
                                        clearDataClick={handleClearFormaPagSelecionado}
                                        setDataClick={handleFormaPagSelectClick}
                                        filterDataClick={handleFilterFormaPagClick}
                                        clicado={clickSearchBoxFormPag}
                                    />
                                </div>

                                <div className={`relative col-span-12 sm:col-span-4`}>
                                    <input id='valor_conta_dup_receber' className={`${classInput} ${classInputDark}`} type='text' inputMode="numeric" placeholder=' ' autoComplete="off" value={valorFormaPag} onFocus={searchBoxFocus} onChange={handleChangeFormaPag} />
                                    <label htmlFor="valor_conta_dup_receber" className={`${classLabel} ${classLabelDark} ${classBorderLabelDark}`}>Valor</label>
                                </div>

                                <div className={`relative col-span-12 sm:col-span-2`}>
                                    <button className={`${classBt} ${classbtVerde} col-span-12 sm:col-span-2`} onFocus={searchBoxFocus} onClick={handleAddFormaPagListClick}>
                                        <FaPlus className="w-3 h-3" />
                                    </button>
                                </div>

                                <div className={`relative col-span-12 mt-1`}>

                                    <div className={`w-full`}>
                                        <ul className={`w-full h-full dark:bg-slate-500 text-slate-700 dark:text-white `}>
                                            <li className={`h-10`}>

                                                <div className={`w-full flex flex-row h-10 font-mono`}>

                                                    <div className={`flex items-center w-[65%] h-full text-sm border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>Forma de Pagamento</span>
                                                    </div>

                                                    <div className={`flex items-center justify-end w-[25%] h-full text-sm border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>Valor</span>
                                                    </div>

                                                    <div className={`flex items-center justify-center w-[10%] h-full text-sm border border-slate-300 dark:border-slate-700`}>
                                                        <span className={`px-1`}>[X]</span>
                                                    </div>

                                                </div>

                                            </li>
                                        </ul>
                                    </div>

                                    <div className={`overflow-auto h-full max-h-[1000px] scrollbar-custom dark:scrollbar-custom-dark`}>

                                        <div className={`w-full`}>

                                            <ul className={`w-full`}>
                                                {lanctoFormaPagList.length > 0 &&
                                                    lanctoFormaPagList.map((item) => (
                                                        <li key={item.id_fpagto} className={`w-full h-auto hover:bg-slate-200 dark:hover:bg-slate-500 duration-150 transition-all`}>
                                                            <div className={`w-full flex flex-row h-[40px] font-mono text-black dark:text-slate-200`}>
                                                                <div className={`flex items-center w-[65%] text-sm break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-1`}>{item.description}</span>
                                                                </div>
                                                                <div className={`flex items-center justify-end w-[25%] text-sm break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <span className={`px-1`}>{Funcoes.numberFormat(item.valor, 'currency', 2, 2)}</span>
                                                                </div>
                                                                <div className={`flex items-center justify-center w-[10%] text-sm break-all border border-slate-300 dark:border-slate-700`}>
                                                                    <button className={`flex items-center justify-center w-6 h-6 rounded-sm text-white transition-all duration-150 ${classbtVermelho}`}
                                                                        onClick={() => handleRemoveFormaPagListClick(item)}>
                                                                        <FaTrashAlt className="w-3 h-3" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </li>
                                                    ))
                                                }
                                            </ul>

                                        </div>

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </div>

                {loading &&

                    <div className={`absolute top-[60px] bottom-[60px] w-full pt-4 bg-slate-300 dark:bg-slate-700 bg-opacity-30 dark:bg-opacity-30 flex justify-center items-center`}>

                        <div className={`h-[60px] w-[60px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-cyan-600 dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                            <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                        </div>

                    </div>
                }

                <div className={`absolute bottom-0 w-full h-[60px] flex items-center justify-end bg-slate-100 dark:bg-slate-600 border border-slate-200 dark:border-slate-500 border-x-0 border-b-0 py-4 px-3 rounded-b-lg space-x-3`}>

                    <button disabled={loading} onClick={fecharModal}
                        className={`${classbtColunasVermelho} max-w-[150px]`} >
                        CANCELAR
                    </button>

                    <button disabled={loading} onClick={handleLiquidarDuplicata}
                        className={`${classbtAzul} ${classBt} max-w-[150px]`}>
                        {loading &&
                            <div className={`h-[20px] w-[20px] mr-1 animate-spin rounded-full border-4 border-solid border-current border-r-transparent align-[-0.125em] text-white dark:text-slate-200 motion-reduce:animate-[spin_1.5s_linear_infinite]`} role="status">
                                <span className={`!absolute !-m-px !h-px !w-px !overflow-hidden !whitespace-nowrap !border-0 !p-0 ![clip:rect(0,0,0,0)]`}>Loading...</span>
                            </div>
                        }
                        {!loading ? 'LIQUIDAR' : 'AGUARDE'}
                    </button>

                </div>

                <ModalImpress
                    visible={visibleImpressDupReceber}
                    titulo="Imprimir duplicata"
                    msg="Escolha o método de impressão"
                    buttonConfirmClickA4={imprimirDupReceberA4}
                    buttonConfirmClickBOBINA={imprimirDupReceberBobina}
                    closeModalEvent={fecharModalImpressDupReceber}
                />

                <ReportReciboContaReceberBobina
                    visible={visibleImpressDupReceberBobina}
                    dadosCliente={dadosParaImpressao?.data?.cliente}
                    dadosDup={dadosParaImpressao?.data?.duplicatas}
                    pagamentos={lanctoFormaPagList}
                    closeModalEvent={fecharModalBobina}
                />

                <ReportReciboContaReceberA4
                    visible={visibleImpressDupReceberA4}
                    dadosCliente={dadosParaImpressao?.data?.cliente}
                    dadosDup={dadosParaImpressao?.data?.duplicatas}
                    pagamentos={lanctoFormaPagList}
                    closeModalEvent={fecharModalA4}
                />

            </div>

        </div>
    )
})